import React, { FC } from 'react';
import { OrderLineDto } from '../../../../../../../generated-api';
import CartItemOptions from '../../CartItemOptions';
import { useLocation } from '../../../../../../context/LocationContext';

interface Props {
  orderLine: OrderLineDto;
}

const CartItem: FC<Props> = ({ orderLine }) => {
  const { formatCurrency } = useLocation();

  return (
    <li className="p-4">
      <div className="flex mb-1">
        <div className="text-bold mr-4">{orderLine.quantity}</div>
        <div className="mr-2">
          <div className="text-bold  truncate-2">{orderLine.name}</div>
          <CartItemOptions options={orderLine.options} />
        </div>
        <div className={`text-small ml-auto`}>{formatCurrency(orderLine.totalPrice)}</div>
      </div>
    </li>
  );
};

export default CartItem;
